module.exports = __webpack_public_path__ + "img/gh.04c6887b.svg";